import React, {Fragment, useContext, useState} from 'react'
import {AppContext} from '../app/app'
import EntityInfo from './entity-info'
import ShipInfo from './ship-info'
import TowableInfo from './towable-info'
import ArtifactsInfo from './artifacts-info'
import AtlasList from './atlas-list'
import EventsList from './events-list'
import FleetList from './fleet-list'
import GameOverStats from '../game-over/stats'
import ResourcesInfo from './resources-info'
import ScoreInfo from './score-info'
import audio from '../launch/audio'

import './css/modal.css'

const Modal = () => {
    const {
        config,
        isGameLoading,
        isModalOpen,
        lastSelectedShipId,
        modalContentType,
        selectedEntityId,
        selectedTowableId,
        setModalContentType,
        toggleGameOverOverlay,
        toggleModal,
    } = useContext(AppContext)
    const [activeTabIndex, setActiveTabIndex] = useState(0)
    const selectedEntity = config.entities[selectedEntityId]
    const selectedShip = config.ships[lastSelectedShipId]
    const selectedTowable = config.towables[selectedTowableId]

    const handleToggleModal = () => {
        toggleGameOverOverlay(true)
        toggleModal()
        setModalContentType(null)
    }
    const buildTabClassName = (index) =>
        `col col-33 modal-header__tab${
            activeTabIndex === index ? ' modal-header__tab--active' : ''
        }`

    if (isGameLoading || (modalContentType === 'entity' && !selectedEntity)) {
        return null
    }

    return (
        <div
            className={isModalOpen ? 'modal modal--open' : 'modal'}
            onClick={() => {
                handleToggleModal()
            }}
        >
            <div
                className="modal-inner"
                onClick={(ev) => {
                    ev.stopPropagation()
                }}
            >
                <div className="modal-header">
                    {modalContentType === 'gameStats' && (
                        <h2>Mission Overview</h2>
                    )}

                    {modalContentType === 'compass' && (
                        <div className="row modal-header__tabs">
                            <div
                                className={buildTabClassName(0)}
                                onClick={(ev) => {
                                    audio.buttonClick()
                                    setActiveTabIndex(0)
                                }}
                            >
                                Log
                            </div>
                            <div
                                className={buildTabClassName(1)}
                                onClick={(ev) => {
                                    audio.buttonClick()
                                    setActiveTabIndex(1)
                                }}
                            >
                                Starmap
                            </div>
                            <div
                                className={buildTabClassName(2)}
                                onClick={(ev) => {
                                    audio.buttonClick()
                                    setActiveTabIndex(2)
                                }}
                            >
                                Fleet
                            </div>
                        </div>
                    )}
                </div>

                <div className="modal-content">
                    {modalContentType === 'gameStats' && <GameOverStats />}
                    {modalContentType === 'entity' && (
                        <EntityInfo
                            entity={selectedEntity}
                            isModalOpen={isModalOpen}
                        />
                    )}
                    {modalContentType === 'ship' && (
                        <ShipInfo ship={selectedShip} />
                    )}
                    {modalContentType === 'compass' && (
                        <Fragment>
                            {activeTabIndex === 0 && (
                                <EventsList isModalOpen={isModalOpen} />
                            )}
                            {activeTabIndex === 1 && (
                                <AtlasList isModalOpen={isModalOpen} />
                            )}
                            {activeTabIndex === 2 && (
                                <FleetList isModalOpen={isModalOpen} />
                            )}
                        </Fragment>
                    )}
                    {modalContentType === 'towable' && (
                        <TowableInfo towable={selectedTowable} />
                    )}
                    {modalContentType === 'artifacts' && <ArtifactsInfo />}
                    {modalContentType === 'resources' && <ResourcesInfo />}
                    {modalContentType === 'score' && <ScoreInfo />}
                </div>

                <button
                    className="button-1 modal-button"
                    onClick={() => {
                        audio.buttonClick()
                        handleToggleModal()
                    }}
                >
                    <span className="modal-close-icon">&times;</span> Close
                </button>
            </div>
        </div>
    )
}

export default Modal
